"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = ({
  className
}) => {
  return _react.default.createElement(_SvgIcon.default, {
    className: className
  }, _react.default.createElement("path", {
    d: "M8.99242 9.366V8.619H3.84442V9.366H6.01342V15H6.83242V9.366H8.99242ZM14.6455 15L12.4225 11.139L14.6365 8.619H13.6465L10.7755 11.895V8.619H9.96547V15H10.7755V13.02L11.8555 11.787L13.7005 15H14.6455ZM19.6685 11.868C19.6685 10.662 19.5605 9.78 18.9305 9.141C18.6245 8.835 18.2015 8.619 17.5805 8.619C16.9595 8.619 16.5365 8.835 16.2305 9.141C15.6005 9.78 15.4925 10.662 15.4925 11.868C15.4925 13.074 15.6005 13.947 16.2305 14.586C16.5365 14.892 16.9595 15.117 17.5805 15.117C18.2015 15.117 18.6245 14.892 18.9305 14.586C19.5605 13.947 19.6685 13.074 19.6685 11.868ZM18.6605 10.05L16.3115 12.93C16.2755 12.588 16.2845 12.219 16.2845 11.868C16.2845 11.022 16.2755 10.104 16.8065 9.6C16.9865 9.429 17.2475 9.312 17.5805 9.312C17.9135 9.312 18.1745 9.429 18.3545 9.6C18.4895 9.726 18.5885 9.879 18.6605 10.05ZM18.8765 11.868C18.8765 12.714 18.8855 13.632 18.3545 14.136C18.1745 14.307 17.9135 14.424 17.5805 14.424C17.2475 14.424 16.9865 14.307 16.8065 14.136C16.6895 14.028 16.5995 13.893 16.5275 13.74L18.8495 10.869C18.8765 11.193 18.8765 11.535 18.8765 11.868Z",
    fill: "black"
  }), _react.default.createElement("path", {
    d: "M1 1H23V-1H1V1ZM23 1V23H25V1H23ZM23 23H1V25H23V23ZM1 23V1H-1V23H1ZM1 23H1H-1C-1 24.1046 -0.104568 25 1 25V23ZM23 23V25C24.1046 25 25 24.1046 25 23H23ZM23 1H25C25 -0.10457 24.1046 -1 23 -1V1ZM1 -1C-0.10457 -1 -1 -0.104568 -1 1H1V1V-1Z",
    fill: "#999999"
  }));
};

exports.default = _default;
module.exports = exports.default;